module.exports = __webpack_public_path__ + "static/media/top14Desktopbanner2440x300.faf3a81e.jpg";